@if (pageReady) {
  <main class="">
    <form [formGroup]="mailingAddressForm" class="mailing-form">
      <mat-form-field class="gs-form-field mailing-address-field" appearance="outline" subscriptSizing="dynamic">
        <mat-label id="address1Label">{{ pageLabels.address1LabelText }}</mat-label>
        <input
          matInput
          class="custom-input"
          formControlName="address1"
          id="address1"
          aria-labelledby="address1Label address1Error"
          maxlength="200"
          (input)="checkFormChanges()"
        />
        @if (mailingAddressForm.get("address1")?.hasError("required")) {
          <mat-error id="address1Error">{{ pageLabels.address1RequiredText }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field class="gs-form-field mailing-address-field" appearance="outline" subscriptSizing="dynamic">
        <mat-label id="address2Label">{{ pageLabels.address2LabelText }}</mat-label>
        <input matInput class="custom-input" formControlName="address2" id="address2" aria-labelledby="address2label" />
      </mat-form-field>
      <mat-form-field class="gs-form-field mailing-address-field" appearance="outline" subscriptSizing="dynamic">
        <mat-label id="cityLabel">{{ pageLabels.cityLabelText }}</mat-label>
        <input
          matInput
          class="custom-input"
          formControlName="city"
          id="city"
          aria-labelledby="cityLabel cityError"
          maxlength="200"
          (input)="checkFormChanges()"
        />
        @if (mailingAddressForm.get("city")?.hasError("required")) {
          <mat-error id="cityError">{{ pageLabels.cityRequiredText }} </mat-error>
        }
      </mat-form-field>
      <div class="row">
        <div class="column stateField">
          <mat-form-field class="gs-form-field" appearance="outline" color="primary">
            <mat-label id="stateLabel">{{ pageLabels.stateLabelText }}</mat-label>
            <mat-select formControlName="state" id="stateSelect" (selectionChange)="checkFormChanges()">
              @for (stateName of stateArray; track stateName) {
                <mat-option [value]="stateName">{{ stateName }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="column postalField">
          <mat-form-field class="gs-form-field mailing-address-field" appearance="outline" subscriptSizing="dynamic">
            <mat-label id="postalCodeLabel">{{ pageLabels.zipCodeLabelText }} </mat-label>
            <input
              matInput
              class="custom-input"
              formControlName="postalCode"
              id="postalCode"
              aria-labelledby="postalCodeLabel postalCodeError postalCodeInvalidError"
              maxlength="5"
              (input)="checkFormChanges()"
            />
            @if (mailingAddressForm.get("postalCode")?.hasError("required")) {
              <mat-error id="postalCodeError">{{ pageLabels.zipCodeRequiredText }}</mat-error>
            } @else if (mailingAddressForm.get("postalCode")?.hasError("invalidZipCode")) {
              <mat-error id="postalCodeInvalidError">{{ pageLabels.zipCodeInvalidText }}</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      @if (addressList.length > 0) {
        <p>{{ pageLabels.addressSearchConfirmationText }}</p>
        <mat-radio-group
          aria-labelledby="example-radio-group-label"
          class="gs-radio-button"
          color="primary"
          formControlName="addressRadioGroup"
        >
          @for (addr of addressList; track addr; let first = $first) {
            <mat-radio-button class="example-radio-button" [value]="addr" (change)="updateForm(addr)" [checked]="first">
              {{ addr.Address1 }} {{ addr.Address2 }} {{ addr.City }} {{ addr.State }} {{ addr.PostalCode }}
            </mat-radio-button>
          }
        </mat-radio-group>
      } @else if (unverifiedAddress) {
        <p>
          {{ pageLabels.addressCannotBeVerifiedText }}
        </p>
      }
      @if (isMultiAccount) {
        <div class="multiAccount-checkbox">
          <mat-checkbox class="default-cb" formControlName="setDefault" id="setDefault">{{
            pageLabels.multiAccountOptionText
          }}</mat-checkbox>
        </div>
      }
    </form>
  </main>
}
